// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";
import CommonReasonInputForm from "./common-reason-input-form";
import { Col, Row, View } from "@components";

type OwnProps = $Exact<{
  title: String,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export const CommonReasonInputView = (props: Props) => {
  return (
    <View flexDirection="column">
      <h6>{props.title}</h6>
      <CommonReasonInputForm {...props} disabled={true} />
    </View>
  );
};

export default localize()(CommonReasonInputView);
